import { GET_STP, GET_STP_ERROR, GET_STP_REQUEST, UPDATE_STP_DATA, REMOVE_STP, SELECTED_PAIR_DETAIL, SELECTED_PAIR_PRICE_DETAIL } from "../../ActionTypes/ActionTypes.js";

const initialState = {
    stpLoading: false,
    stpData: null,
    stpError: null,
    stpStatus: null,
    isModified: false,
    isFirstLoad: true,
    selectedPair: null,
    selectedPrice: null

};

const TradePageSTPReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_STP_REQUEST:
            return { ...state, stpLoading: true, stpStatus: null, stpData: null };
        case GET_STP:
            return {
                stpLoading: false, stpData: action.payload, selectedPair: action.payload?.result?.[0], stpError: null, stpStatus: action?.payload?.success,

                isFirstLoad: false,
            };

        case GET_STP_ERROR:
            return { stpLoading: false, stpData: null, stpError: action?.payload, stpStatus: action?.payload?.success, isFirstLoad: false, };
        case UPDATE_STP_DATA:
            return {
                ...state,
                stpData: {
                    ...state.stpData,
                    result: {
                        ...state.stpData.result,
                        ...action.payload,
                    },
                },
            };
        case REMOVE_STP:
            return { ...state, stpData: null, stpError: null, isModified: false, stpStatus: null, isFirstLoad: true, stpLoading: false, selectedPair: null }
        case SELECTED_PAIR_DETAIL:

            return { ...state, selectedPair: action.payload }
        case SELECTED_PAIR_PRICE_DETAIL:

            return { ...state, selectedPrice: action.payload }
        default:
            return state;
    }
};

export default TradePageSTPReducer;